export default __webpack_public_path__ + "static/media/cup.4c2e368e.svg";